import React, { useContext, useEffect, useState } from "react";
import { MdOutlineBusiness } from "react-icons/md";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import ApiErrorAlert from "../ApiErrorAlert";

const CompanySwitcher = ({ user, className = "" }) => {
  const { handleSelectCompany } = useContext(AuthContext);
  const isRoot = user?.profile === "root";

  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isRoot) return;

    (async () => {
      try {
        const { data } = await api.get("/companies/list");
        setCompanies(data || []);
      } catch (err) {
        setError(err);
      }
    })();
  }, [isRoot]);

  if (!user?.id || !isRoot) return null;

  const handleChange = async (e) => {
    const { value } = e.target;
    const companyId = value === "" ? null : Number(value);

    setLoading(true);
    setError(null);
    try {
      await handleSelectCompany(companyId);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  return (
    <div
      className={`relative hidden items-center gap-3 rounded-2xl border border-farmazon-border bg-farmazon-surface p-2 shadow-sm sm:flex ${className}`}
    >
      <MdOutlineBusiness className="h-4 w-4 flex-shrink-0 text-farmazon-text-muted" />

      <select
        value={user.companyId ?? ""}
        onChange={handleChange}
        disabled={loading}
        className="h-8 flex-shrink-0 rounded-lg border border-farmazon-border bg-[var(--farmazon-surface)] px-2 text-xs text-farmazon-text-muted outline-none disabled:opacity-60"
      >
        <option value="">Selecionar empresa</option>
        {companies.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </select>

      {error && (
        <div className="absolute left-0 top-full z-[1500] mt-2 w-72">
          <ApiErrorAlert error={error} onClose={() => setError(null)} />
        </div>
      )}
    </div>
  );
};

export default CompanySwitcher;
